<div class="customer-details-card p-20">

    <app-card cardTitle="{{'notes' | translate}}" [padding]="20">
        <ng-template #headerOptionsTemplate>
            <a href="javascript:" class="text-muted" mat-dialog-close>
                <i class="ti ti-x f-20"></i>
            </a>
        </ng-template>
        <div class="personal-details">
            <div class="row">
                <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-9">
                                <mat-form-field appearance="outline" class="w-100 m-t-5">
                                    <input type="text" #noteElement matInput formControlName="note"
                                        placeholder="{{'enterNote' | translate}}" />
                                </mat-form-field>
                            </div>
                            <div class="col-sm-3">
                                <button mat-flat-button class="w-100 m-t-5" color="primary">{{'save' |
                                    translate}}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div mat-dialog-content class="row">
                @for (row of viewData; track row; let last = $last) {
                <div class="col-md-12 row">
                    <div class="col-md-8 row" style="padding-inline-start: 0;">
                        <div class="col-md-6">
                            <label class="text-capitalize">{{'creator' | translate}} : </label>
                            <p class="m-b-5 text-muted d-inline-block"> {{ row.creatorname }} </p>
                        </div>

                        <div class="col-md-6">
                            <label class="text-capitalize">{{'creationTime' | translate}} : </label>
                            <p class="m-b-5 text-muted d-inline-block"> {{ row.creationtime | date: 'dd/MM/yyyy' }} </p>
                        </div>

                        @if (row.lastmodifiername) {
                        <div class="col-md-6">
                            <label class="text-capitalize">{{'lastModifier' | translate}} : </label>
                            <p class="m-b-5 text-muted d-inline-block"> {{ row.lastmodifiername }} </p>
                        </div>

                        <div class="col-md-6">
                            <label class="text-capitalize">{{'lastModification' | translate}} : </label>
                            <p class="m-b-5 text-muted d-inline-block"> {{ row.lastmodificationtime | date: 'dd/MM/yyyy'
                                }}
                            </p>
                        </div>
                        }
                        <div class="col-md-12">
                            <label class="text-capitalize">{{'noteContent' | translate}} : </label>
                            <p class="d-inline-block">{{ row.note }}</p>
                        </div>
                    </div>
                    <div class="col-md-4" style="display: inline-block;text-align: end;">
                        <a href="javascript:" class="avatar avatar-xs text-muted" matTooltip="Edit"
                            (click)="edit(row.id)">
                            <i class="ti ti-edit-circle f-18"></i>
                        </a>

                        <a href="javascript:" class="avatar avatar-xs text-warn-500" matTooltip="Delete"
                            (click)="delete(row.id)">
                            <i class="ti ti-trash f-18"></i>
                        </a>
                    </div>
                </div>
                @if(!last) {
                <hr class="w-100" />
                }
                }
            </div>
        </div>

    </app-card>

</div>